import * as Material from "@material-ui/core";
import * as Bootstrap from "react-bootstrap";
import styled from "styled-components";
import theme from "theme";

const containerWidth = 1280;

export const AppBar = styled.div`
  background-color: ${theme.palette.primary.main};
`;

export const AppMenuBar = styled.div`
  background-color: ${theme.palette.primary.light};
  width: 100%;
  margin: 0;
`;

export const AppFooterBar = styled.div`
  background-color: ${theme.palette.primary.light};
  width: 100%;
`;

export const AppFooterContainer = styled(Bootstrap.Row)`
  width: 100%;
`;

export const AppBarContainer = styled.div`
  margin: auto;
  width: ${containerWidth}px;
`;

export const AppBarItem = styled(Bootstrap.Col)`
  padding: 10px 0;
  text-transform: uppercase;
  color: white;
  font-weight: bold;
  &:first {
    text-align: left;
  }

  &:last-child {
    text-align: right;
  }

  & .menu-items {
    display: none;
  }

  &:hover .menu-items {
    display: block;
  }
`;

export const Menu = styled.div`
  display: inline-block;
  text-align: right;
  margin: 0 -20px 0 -180px;
  padding: 0 0 0 200px;
  width: 100%;
`;

export const MenuButton = styled(Material.Button)({
  margin: "11px",
  'font-weight': "bold",
  '&:hover': {
    opacity: 0.5,
    backgroundColor: 'transparent',
  }
})

export const ContainerTitle = styled.h1`
  margin: 30px 0;
`;

export const SessionTitle = styled.h4`
  margin: 100px 0 30px;
  text-align: left;
`;

export const BoxTitle = styled.h6`
  background-color: #774EA4; 
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  text-align: center;
  line-height: 40px;
  margin: 0 auto;
  width: 320px;
  max-width: 100%;
`;

export const ButtonContainer = styled(Bootstrap.Row)`
  margin: 60px -15px;
`;

export const FullSizedButton = styled(Material.Button)`
  width: 100%;
  height: 55px;
  margin-top: 17px;
`;

export const FullSizedButtonMenu = styled(Material.Button)({
  width: "100%",
  height: "55px",
  margin: "8px 0",
  display: "block",
  '&&&': {
    borderRadius: "0px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px"
  }
})

export const LogoContainer = styled.div`
  width: 200px;
  display: inline-block;
  vertical-align: middle;
`;

export const Logo = styled.img`
  margin: 20px 100px 20px 0;
  max-width: 200px;
`;

export const LogoPrevic = styled(Logo)`
  margin-top: 40px;
`;

export const LogoDataA = styled(Logo)`
  margin-top: 40px;
`;

export const Container = styled(Material.Container)`
  padding: ${theme.spacing(4)}px 0 ${theme.spacing(4)}px 0;
  width: ${containerWidth}px;
`;

export const Content = styled.main`
  flex-grow: 1;
  overflow: auto;
`;

export const Root = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: white;
`;

export const OverlayMenu = styled.div`
  position: absolute;
  height: 1px;
`;

export const CloseDrawerButton = styled.div`
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
`;

export const ModalBody = styled.div`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: 400px;
  max-width: 90%;
  background-color: white;
  -webkit-box-shadow: 5px 5px 15px 5px #000000;
  box-shadow: 5px 5px 15px 5px #000000;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  padding: 20px;
`;

export const ModalCloseButton = styled(Material.Button)`
  float: right;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
`;
